import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { SharepointService } from '../../service';

export type FileSyncConfig = typeof FileSyncConfig._.Config;

export const FileSyncConfig = IntegrationConfig.make({
  service: SharepointService,
  name: Integration_Handler_Names_Enum.FileSync,
  configSchema: z.object({
    driveId: z.string().min(1),
    fileId: z.string().min(1),
    fileName: z.string().min(1),
  }),
});
